import styled from 'styled-components'

export const StyledProjectsWrapper = styled.div`
  .projects-table {
    &__create-date {
      display: inline-grid;
      align-items: center;
      justify-content: center;
    }
    &__key-expired {
      display: inline-grid;
      justify-content: end;
    }
  }
  .project-head {
    padding: 15px 0 25px;
    display: grid;
    align-items: center;
    grid-template-columns: max-content 175px 1fr;
    grid-gap: 25px;
    @media screen and (max-width: 768px) {
      grid-template-columns: max-content 175px;
      grid-gap: 20px;
    }
    @media screen and (max-width: 576px) {
      grid-template-columns: 100%;
    }
    
    &__create {
      display: inline-grid;
      align-items: center;
      grid-template-rows: 45px;
      justify-content:  end;
      button {
        height: 100%;
      }
      @media screen and (max-width: 992px) {
        justify-content:  start;
      }
    }
  }
`;